// Read-only queries over a World: hit-testing, counts and derived stats.
// Nothing here mutates a World or an Aircraft, schedules anything, or
// advances time — that's world.ts's step(). Keep it that way.
import type { Aircraft } from './types.ts';
import type { World } from './world.ts';

/** nearest steerable aircraft within `radius` logical px, or null */
export function planeAt(w: World, x: number, y: number, radius = 38): Aircraft | null {
  let best: Aircraft | null = null, bd = radius;
  for (const p of w.planes) {
    if (p.rollout > 0) continue;
    const d = Math.hypot(p.x - x, p.y - y);
    if (d < bd) { bd = d; best = p; }
  }
  return best;
}

export function airborneCount(w: World): number {
  let n = 0;
  for (const p of w.planes) if (p.rollout === 0) n++;
  return n;
}

/** an aircraft "needs attention" if it is airborne and has no path (and is not holding) */
export function needsAttention(p: Aircraft): boolean {
  return p.rollout === 0 && !p.holding && p.path.length === 0;
}

export function meanAirborne(w: World): number { return w.elapsed > 0 ? w.stats.airborneTime / w.elapsed : 0; }
